import Store from "App/Store.js";
import dReset from "./dReset.js";

export default cookieDomain => {
	dReset();
	Store.dispatch({type: "cookieDomain", cookieDomain});
};
